import clientAuth from "../clientAuth";
import client from "../client";
let lng = localStorage.getItem('lng') ? localStorage.getItem('lng'):'de';
export default {
  // get brands 


  index: () =>client.get(`camperVans/index?lng=`+lng),
  policiesindex: () =>client.get(`cancellation/index?lng=`+lng),
  subIndex: () =>client.get(`camperVans/subIndex?lng=`+lng),

  sale_index: () =>client.get('sale/index'),
  // subIndex: () =>client.get('camperVans/subIndex'),
  kilometer: () =>client.get(`camperVans/kilometer?lng=`+lng),
  //
  kilometerindex :()=>client.get(`kilometer/index?lng=`+lng),
 
  checkaccessoires: (userData) => client.post(`camperVans/checkaccessoires?lng=`+lng, { json: userData }),
  
  // b_index: () => clientAuth.get("brand/index"),
  show:(id)=>client.get(`camperVans/show/${id}?lng=`+lng), 
  checkdate: (userData) =>client.post('checkdate/index',{ json: userData }),

  camper_filter: (userData) =>client.post('camperVans/camper_filter',{ json: userData }),
  
  excludedates:(camper_id)=>client.get(`checkdate/excludedates/${camper_id}?lng=`+lng), 
  //minimum rent duration
  minimum_duration: (userData) =>client.post(`camperVans/minimum/rent/duration?lng=`+lng,{ json: userData }),
  Single_camper_minimum_duration: (userData) =>client.post(`camperVans/minimum/rent/duration/camper/detail?lng=`+lng,{ json: userData }),
  // unavailabledate :(camper_id)=>client.get(`restrictedUnavailabledate/unavailabledate/${camper_id}?lng=`+lng),
  unavailabledate :(userData)=>client.post(`restrictedUnavailabledate/unavailabledate?lng=`+lng,{ json: userData }),
  all_capmer_unavailabledate :()=>client.get(`URcamper/unavailableindex?lng=`+lng),
  // restricteddate :(camper_id)=>client.get(`restrictedUnavailabledate/restricteddate/${camper_id}?lng=`+lng),
  restricteddate :(userData)=>client.post(`restrictedUnavailabledate/restricteddate?lng=`+lng,{ json: userData }),
  all_camper_restricteddate :()=>client.get(`URcamper/restrictedindex?lng=`+lng),
  checkunavailabledate :(userData)=>client.post(`camperVans/subscription/unavailabledate/check?lng=`+lng,{ json: userData }),
  pickupreturndate :()=>client.get(`URcamper/calendar/automatic-orange-dates/pickupreturn?lng=`+lng),

  camper_time_slots_index :(userData)=>client.post(`time_slots/index?lng=`+lng,{ json: userData }),
  discountMonthsList :()=>client.get(`time_slots/discountMonthsList?lng=`+lng),
};